import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios';
import CurrencyInput from '../../../../helpers/CurrencyInput';
import MultiTagInput from '../../component/MultiTagInput/MultiTagInput';
import { getToken } from '../../../../helpers/Jwt';
import { confirmModal } from '../../../../helpers/PromptUtils';
import AccountComponent from './component/AccountComponent';
import InputOption from '../../component/InputOption/InputOption';
import FormatTransaction from '../../component/FormatTransaction/FormatTransaction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears } from '@fortawesome/free-solid-svg-icons';

const EntryExpenses = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [detailData, setDetailData] = useState(null);
  const [itemData, setItemData] = useState([]);

  const [initialValues, setInitialValues] = useState({});

  const [error, setError] = useState(null);
  const [cashbank, setCashBank] = useState([]);
  const [cashbankLabel, setCashBankLabel] = useState("Bayar Dari");
  const [contact, setContact] = useState([]);
  const [contactLabel, setContactLabel] = useState("Penerima");
  const [accountRelationLabel, setAccountRelationLabel] = useState("Akun Biaya");

  const [paymentMethods, setPaymentMethods] = useState([]);

  const [accounts, setAccounts] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [taxAmount, setTaxAmount] = useState(0);

  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);

  const [selectedTags, setSelectedTags] = useState([]);

  const [isFormatTransactionOpen, setFormatTransactionOpen] = useState(false);

  // Validation schema (using Yup)
  const validationSchema = Yup.object({
    // description: Yup.string().required('Deskripsi diperlukan'),
    // amount: Yup.number().required('Jumlah diperlukan').positive('Jumlah harus lebih besar dari nol'),
  });

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_ACCOUNT_CASH_BANK = "api/erpppsu/account/cashbank";
  const PATH_ACCOUNT_EXPENSE = "api/erpppsu/account/expense";
  const PATH_TRANSACTION = "api/erpppsu/expenses";
  const PATH_CONTACT = "api/erpppsu/contact/all";
  const PATH_PAYMENT_METHOD = "api/erpppsu/data/paymentmethod";

  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchData(`${BASE_URL}${PATH_TRANSACTION}/detail?id=${id}`).then((data) => {
        setDetailData(data)
      });

      fetchData(`${BASE_URL}${PATH_TRANSACTION}/items?id=${id}`).then((data) => {
        setItemData(data)
      });
    }
  }, [id]);

  useEffect(() => {

    if (detailData != null) {
      setInitialValues(prev => ({
        ...prev,
        customer: detailData?.receiver_id || '',
        date: detailData?.date || '',
        due_date: detailData?.due_date || '',
        no_transaction: detailData?.no_transaction || ''
      }));
    }


  }, [detailData]);

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_ACCOUNT_CASH_BANK}`,).then((data) => {
      setCashBank(data);
    });

    fetchData(`${BASE_URL}${PATH_CONTACT}`,).then((data) => {
      setContact(data);
    });

    fetchData(`${BASE_URL}${PATH_PAYMENT_METHOD}`,).then((data) => {
      setPaymentMethods(data);
    });
  }, []);

  useEffect(() => {
    setTaxes(groupByTax(accounts));
  }, [accounts]);

  useEffect(() => {
    const totalTaxes = taxes.reduce((acc, tax) => acc + (tax.totalTax || 0), 0);
    const finalTotal = subtotal + totalTaxes;

    setTaxAmount(totalTaxes);
    setTotal(finalTotal);
  }, [taxes]);

  const handleTagsChange = (tags) => {
    setSelectedTags(tags);
  };

  const handleAccountUpdate = (data) => {
    setAccounts(data);
  };

  const groupByTax = (items) => {
    const grouped = items.reduce((acc, item) => {
      const tax_name = item.tax_name;
      if (!acc[tax_name]) {
        acc[tax_name] = {
          tax_id: item.tax_id,
          taxRate: item.tax,
          tax_name: item.tax_name,
          items: [],
          totalTaxableAmount: 0,
          totalTax: 0,
        };
      }

      // Calculate taxable amount and tax
      const taxableAmount = item.amount;
      const tax = (taxableAmount * item.tax) / 100;

      // Update the group
      acc[tax_name].items.push(item);
      acc[tax_name].totalTaxableAmount += taxableAmount;
      acc[tax_name].totalTax += tax;

      return acc;
    }, {});

    // Convert object to array
    return Object.values(grouped);
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        id,
        ...values,
        amount: total,
        tax_amount: taxAmount,
        subtotal,
        selectedTags,
        accounts
      };

      const response = await axios.post(`${BASE_URL}${PATH_TRANSACTION}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      });
      
      const confirmed = confirmModal(response.data);
      if (confirmed) {
        window.location.reload();
      }
    } catch (error) {
      alert(error.response.data);

    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className='flex items-center justify-between px-5'>
        <h2 className="text-2xl font-bold mb-4">
          Buat Biaya
        </h2>

        <div className='flex items-center'>
        </div>
      </div>

      {/* Formik Form */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            <div className="container m-auto p-4">
              <div className="container m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                <div className="p-3">
                  <label htmlFor="source_cashbank" className="mb-1 text-sm font-semibold">Transfer Dari</label>
                  <InputOption
                    label="Pilih Data"
                    data={cashbank}
                    placeholder="Ketik disini"
                    defaultValue={detailData?.source_cashbank}
                    onChange={(value) => {
                      setFieldValue(`source_cashbank`, value);
                    }}
                    returnKey="code"                    />
                </div>

                <div></div>
                <div></div>
                <div></div>

                <div className="p-3">
                  <label htmlFor="contact" className="mb-1 text-sm font-semibold">{contactLabel}</label>
                  <InputOption
                    label="Pilih Akun"
                    data={contact}
                    defaultValue={detailData?.receiver_id}
                    placeholder="Ketik disini"
                    onChange={(value) => {
                      setFieldValue(`contact`, value);
                    }} />
                </div>


                <div className="p-3">
                  <label htmlFor="date" className="mb-1 text-sm font-semibold">Tgl. Transaksi</label>
                  <Field
                    type='date'
                    name="date"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="date" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                  <label htmlFor="due_date" className="mb-1 text-sm font-semibold">Tgl. Jatuh Tempo</label>
                  <Field
                    type='date'
                    name="due_date"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="due_date" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                  <label htmlFor="method_payment" className="mb-1 text-sm font-semibold">Cara Pembayaran</label>
                  <Field
                    as="select"
                    name="method_payment"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    onChange={(e) => setFieldValue(`method_payment`, e.target.value)}
                  >
                    <option value="">Pilih Metode</option>
                    {paymentMethods?.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.id} - {data.name}
                      </option>
                    ))}
                  </Field>
                </div>

                <div className="p-3">
                  <FormatTransaction
                    show={isFormatTransactionOpen}
                    onClose={() => setFormatTransactionOpen(false)}
                    apply={(value) => {
                      setFieldValue('no_transaction', value);
                    }} />

                  <label htmlFor="no_transaction" className="mb-1 text-sm font-semibold">
                    No. Transaksi&nbsp;
                    <button type="button" onClick={() => setFormatTransactionOpen(true)}>
                      <FontAwesomeIcon icon={faGears} />
                    </button>
                  </label>
                  <Field
                    name="no_transaction"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="no_transaction" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                  <MultiTagInput name="tags" options={['Sales', 'PPSU', 'PRSU', 'KMPSUMUT', 'TIKET']} onTagsChange={handleTagsChange} />
                </div>
              </div>

              <AccountComponent
                label={accountRelationLabel}
                items={itemData}
                onAccountUpdated={handleAccountUpdate}
                onAmountUpdated={(value) => {
                  setSubtotal(value);
                  setTotal(value);
                }}
              />

              <div className="container m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                <div></div>
                <div></div>
                <div className='col-span-2'>
                  <div className="flex items-center justify-between mb-6">
                    <h1 className="text-lg font-semibold">Subtotal</h1>
                    <h1 className="text-lg font-semibold">Rp{subtotal.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                  </div>

                  {taxes?.map((data) => (
                    <div className="flex items-center justify-between">
                      <p>{data.tax_name}</p>
                      <p>Rp{data.totalTax.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                    </div>
                  ))}

                  <div className="border-t-2 border-dashed border-gray-300 my-6"></div>
                  <div className="flex items-center justify-between">
                    <h1 className="text-lg font-semibold">Total</h1>
                    <h1 className="text-lg font-semibold">Rp{total.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                  </div>
                </div>
              </div>



              <div className="flex items-center justify-end mt-5">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                >
                  {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div >
  )
}

export default EntryExpenses;